import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import moment from 'moment';

import { NS_COMMON, NSC_PATIENT, NSPP_PATIENT } from '../../../services/i18n/namespaces';

export default function EuiSsuPatientInfoChips({ ssuPatientInfo }) {
  const { t } = useTranslation();
  const { patientFullName, dateOfBirth, subjectId, patientId, studyName, siteName } = ssuPatientInfo;
  const formattedDob = useMemo(
    function() {
      return `${moment(dateOfBirth).format('DD/MMM/YYYY')} (${moment().diff(dateOfBirth, 'years')} ${t('years')})`;
    },
    [dateOfBirth, t]
  );
  return (
    <div className="notes-chips">
      {patientFullName && (
        <Chip size="small" label={`${t(`${NSPP_PATIENT}:info.patientName`)}: ${patientFullName}`} sx={getSx(14 + 17)} />
      )}
      <Chip size="small" label={`${t(`${NSPP_PATIENT}:info.dob`)}: ${formattedDob ? formattedDob : 'N/A'}`} />
      <Chip
        size="small"
        label={`${t(`${NSC_PATIENT}:subjectId`)}: ${subjectId ? subjectId : 'N/A'}`}
        sx={getSx(11 + 7)}
      />
      <Chip
        size="small"
        label={`${t(`${NSC_PATIENT}:patientId`)}: ${patientId ? patientId : 'N/A'}`}
        sx={getSx(11 + 40)}
      />
      <Chip size="small" label={`${t(`${NS_COMMON}:study`)}: ${studyName ? studyName : 'N/A'}`} sx={getSx(6 + 40)} />
      <Chip size="small" label={`${t(`${NS_COMMON}:site`)}: ${siteName ? siteName : 'N/A'}`} sx={getSx(6 + 40)} />
    </div>
  );
}

function getSx(length) {
  return {
    '> span': {
      maxWidth: `${length}ch`
    }
  };
}
